import logger from './logger';
import { setConfigFeatures, getConfigObject } from './config';
const VERSION1 = '/api/v1';

const makeRequest = async (url, params) => {
  try {
    const response = await fetch(url, params);
    const result = await response.json();

    if (result.status >= 400) {
      const errorMessage = `Error ${result.status}: ${result.message} ${result.id}`;
      logger(errorMessage);
      return {
        error: errorMessage,
      };
    }
    return result;
  } catch (e) {
    logger(e.message);
    return {
      error: e.message,
    };
  }
};

export const getRequest = async (url) =>
  await makeRequest(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Pragma: 'no-cache',
    },
  });

export const postRequest = async (url, body) =>
  await makeRequest(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
    },
    body: JSON.stringify(body),
  });

export const deleteRequest = async (url, body) =>
  await makeRequest(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
    },
    body: JSON.stringify(body),
  });

export const getConfig = async () => {
  const { DASHBOARD_API_URL } = getConfigObject();
  const apiHost = DASHBOARD_API_URL;
  const config = await getRequest(`${apiHost}${VERSION1}/dashboards/config`);
  setConfigFeatures(config);
  return config;
};
